import styled from 'styled-components';

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  height: 1px;
  width: 100%;
`;
